import { render, staticRenderFns } from "./TwoLinkBlock.vue?vue&type=template&id=0942e936"
import script from "./TwoLinkBlock.vue?vue&type=script&lang=js"
export * from "./TwoLinkBlock.vue?vue&type=script&lang=js"
import style0 from "./TwoLinkBlock.vue?vue&type=style&index=0&id=0942e936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports